export const profileNavigationTabsType = {
  OVERVIEW: 'overview',
  SETTINGS: 'settings',
  EVENTS_LOGS: 'events_logs'
};

export const profileNavigationTabs = [
  {
    title: 'Overview',
    type: profileNavigationTabsType.OVERVIEW
  },
  {
    title: 'Settings',
    type: profileNavigationTabsType.SETTINGS
  }
];

export const userProfileNavigationTabs = [
  {
    title: 'Overview',
    type: profileNavigationTabsType.OVERVIEW
  },
  {
    title: 'Events & Logs',
    type: profileNavigationTabsType.EVENTS_LOGS
  },
];
